module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-panel padded"
  }, [_c('extra-form', {
    attrs: {
      "isEdit": true
    },
    on: {
      "toggleIsDisabled": _vm.toggleIsDisabled,
      "readyToSave": _vm.readyToSave
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-63f90252", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f90252"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/extras/ExtraEdit.vue
// module id = 1538
// module chunks = 0